/**
 * @class MainCollection
 * @classdesc The canonical collection section component intended for the collection page.
 *
 * @extends Core.SectionComponent
 */
export default class MainCollectionGrid extends Core.SectionComponent {
  constructor(el, context) {
    super(el, context);

    this.productList = el.querySelector('[data-product-list]');

    this.events.register(window, 'popstate', e => this._onHistoryChange(e));
  }

  onMount() {
    this.filters = this.query('faceted-filters');
    this.mobileFilters = this.query('faceted-filters-mobile');

    if (this.filters) {
      this.events.register(this.filters.el, 'filter:update', e => {
        const { searchParams } = e.detail;

        this._updateSectionContent(searchParams);

        history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
      });
    }

    if (this.mobileFilters) {
      this.events.register(this.mobileFilters.el, 'filter:update', e => {
        const { searchParams } = e.detail;

        this._updateSectionContent(searchParams);

        history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
      });
    }
  }

  onDismount() {
    this.events.unregisterAll();
  }

  /**
   * This handles what happens when the history of the browser changes. This it triggered when the
   * back button is hit in the browser.
   *
   * @param {Event} e - The event sent by the browser changing its history
   * (usually using the back/forward buttons).
   * @private
   */
  _onHistoryChange(e) {
    this._updateSectionContent(e.state ? e.state.searchParams : '');
  }

  /**
   * This handles a call to update the section's content (including filters) when the filters in the
   * section are updated or history changes on the page.
   *
   * @param {String} searchParams - The URL params that are used to filter and sort the list of
   * products on the page.
   * @private
   */
  _updateSectionContent(searchParams) {
    const url = `${window.location.pathname}?section_id=${this.sectionId}&${searchParams}`;

    fetch(url)
      .then(response => response.text())
      .then(html => {
        const newDom = new DOMParser().parseFromString(html, 'text/html');

        this.productList.innerHTML = newDom.querySelector('[data-product-list]').innerHTML;

        this.filters.updateFilters(newDom);
        this.mobileFilters.updateFilters(newDom);
      });
  }
}
